var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoO3Digital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 371.2 316.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_10);}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_10-2);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_10-3);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_10-4);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_10-5);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_10-6);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_10-7);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_10-8);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_10-9);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_10-10);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10",
    x1: 224.9,
    y1: 135.55,
    x2: -197.89,
    y2: 403.2,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 320.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6332a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e9492c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ef7a31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-2",
    x1: 181.98,
    y1: 67.75,
    x2: -240.81,
    y2: 335.39,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-3",
    x1: 195.39,
    y1: 88.92,
    x2: -227.41,
    y2: 356.57,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-4",
    x1: 184.83,
    y1: 72.24,
    x2: -237.97,
    y2: 339.89,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-5",
    x1: 189.87,
    y1: 80.2,
    x2: -232.93,
    y2: 347.85,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-6",
    x1: 209.98,
    y1: 111.97,
    x2: -212.82,
    y2: 379.62,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-7",
    x1: 199.42,
    y1: 95.29,
    x2: -223.38,
    y2: 362.93,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-8",
    x1: 206.2,
    y1: 106.01,
    x2: -216.59,
    y2: 373.66,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-9",
    x1: 210.98,
    y1: 113.56,
    x2: -211.81,
    y2: 381.2,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10-10",
    x1: 221.59,
    y1: 130.31,
    x2: -201.21,
    y2: 397.96,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.2,162.8c0-10.8-2.9-20-8.5-27.9s-14.1-12.5-25.2-14.2v-.5c9.3-2.3,16.5-7,21.7-14.3A41.34,41.34,0,0,0,367,81.1a43.27,43.27,0,0,0-4.5-20.2,41.28,41.28,0,0,0-12.1-14.4,54.68,54.68,0,0,0-17.6-8.7,74.08,74.08,0,0,0-21.3-2.9,72.82,72.82,0,0,0-18.3,2.2,57.62,57.62,0,0,0-16.1,6.7,46.65,46.65,0,0,0-12.7,11.6A51.73,51.73,0,0,0,256.1,72l31,8.3a28.19,28.19,0,0,1,10.1-14,26.53,26.53,0,0,1,15.8-5c7.3,0,13.3,2.1,17.8,6.4s6.8,9.7,6.8,16.4c0,5.2-1,9.4-2.9,12.5a19.44,19.44,0,0,1-7.7,7.1,33.36,33.36,0,0,1-10.7,3.2,99.18,99.18,0,0,1-12.3.7h-7.6V134h7.1a87.27,87.27,0,0,1,13.4,1,38.54,38.54,0,0,1,12.3,3.8,23.39,23.39,0,0,1,9,8.1c2.4,3.5,3.5,8,3.5,13.6a26.54,26.54,0,0,1-2.3,11.1,27.25,27.25,0,0,1-6.4,8.6,29,29,0,0,1-9.3,5.5,31.65,31.65,0,0,1-11.1,2c-7.8,0-14-2-18.6-5.9s-7.7-9.4-9.5-16.6l-.5.1a99.78,99.78,0,0,0-6.8-36.6,84.35,84.35,0,0,0-19.1-28.8A80.74,80.74,0,0,0,229,81.7,97.44,97.44,0,0,0,200.9,76l.1-26.6a23.4,23.4,0,1,0-26.2-8,24,24,0,0,0,11,8L185.7,76a100.33,100.33,0,0,0-30.6,6.3,82,82,0,0,0-25.5,15.4L68.8,51.4a35.38,35.38,0,0,0,3.4-15.3A36.08,36.08,0,1,0,59.5,63.6L119.1,109a89.8,89.8,0,0,0-11.8,20.8c-4.6,11.3-6.8,23.9-6.8,37.7a97.37,97.37,0,0,0,6.8,36.9,84.81,84.81,0,0,0,16.5,26l-25,24.3A30,30,0,0,0,88.4,251a28.86,28.86,0,1,0,24.3,32.8,28.37,28.37,0,0,0-3.3-18.2l25.8-25.1a86.76,86.76,0,0,0,19.7,10.7,101.61,101.61,0,0,0,36.8,6.5,102.93,102.93,0,0,0,37.1-7A88.18,88.18,0,0,0,257.9,232a85.11,85.11,0,0,0,18.2-26.5,58.4,58.4,0,0,0,16,6.5,88.28,88.28,0,0,0,20.3,2.3,73.92,73.92,0,0,0,22.1-3.3,56.56,56.56,0,0,0,18.7-9.8,46.52,46.52,0,0,0,12.8-16C369.6,178.5,371.2,171.2,371.2,162.8ZM247.7,190.9a61.57,61.57,0,0,1-12.1,20.3,55.19,55.19,0,0,1-18.8,13.4,58.77,58.77,0,0,1-24.4,4.9,58,58,0,0,1-24.3-4.9,56.17,56.17,0,0,1-18.7-13.4,61.57,61.57,0,0,1-12.1-20.3,73.35,73.35,0,0,1-4.3-25.7,66.63,66.63,0,0,1,4.3-24.2,60.2,60.2,0,0,1,12.1-19.7,55.65,55.65,0,0,1,18.7-13.2,59.55,59.55,0,0,1,24.3-4.8,60.37,60.37,0,0,1,24.4,4.8,56.06,56.06,0,0,1,18.8,13.2A60.85,60.85,0,0,1,247.7,141a68.81,68.81,0,0,1,4.3,24.2A73.35,73.35,0,0,1,247.7,190.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.5,279.4h-.1a13,13,0,0,0-3.9-3.4,11.85,11.85,0,0,0-5.8-1.4,14.71,14.71,0,0,0-5.6,1.1,11.92,11.92,0,0,0-4.3,3,14.19,14.19,0,0,0-2.8,4.6,16.88,16.88,0,0,0-1,5.6,14.67,14.67,0,0,0,1,5.6,14,14,0,0,0,2.7,4.6,13.55,13.55,0,0,0,4.3,3.1,14.85,14.85,0,0,0,5.7,1.1,12.42,12.42,0,0,0,5.6-1.3,9.67,9.67,0,0,0,4.2-3.8h.1v4.3h5.2V259.2h-5.4v20.2Zm-.3,13.2a8.94,8.94,0,0,1-1.9,3.1,8.64,8.64,0,0,1-2.9,2.1,9.21,9.21,0,0,1-3.8.8,9.35,9.35,0,0,1-3.9-.8,8.55,8.55,0,0,1-2.8-2.2,9.41,9.41,0,0,1-1.7-3.1,11.71,11.71,0,0,1,0-7.4,10.3,10.3,0,0,1,1.7-3.1,10.11,10.11,0,0,1,2.8-2.2,9.35,9.35,0,0,1,3.9-.8,9.57,9.57,0,0,1,3.8.8,8.93,8.93,0,0,1,2.9,2.2,12.3,12.3,0,0,1,1.9,3.1,11.56,11.56,0,0,1,.7,3.7A9.86,9.86,0,0,1,231.2,292.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249,262a3.42,3.42,0,0,0-3.5,3.5,3,3,0,0,0,1,2.4,3.63,3.63,0,0,0,5,0,3.25,3.25,0,0,0,1.1-2.5,3.41,3.41,0,0,0-1.1-2.5A3.49,3.49,0,0,0,249,262Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 246.4,
    y: 275.3,
    width: 5.4,
    height: 27.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.9,279.6h-.1a9.11,9.11,0,0,0-4.2-3.8,13.52,13.52,0,0,0-5.6-1.3,14.34,14.34,0,0,0-5.6,1.1,13.29,13.29,0,0,0-4.3,3,12.88,12.88,0,0,0-2.7,4.5,16.29,16.29,0,0,0-1,5.5,14.51,14.51,0,0,0,1,5.5,13,13,0,0,0,2.7,4.4,11.92,11.92,0,0,0,4.3,3,14.71,14.71,0,0,0,5.6,1.1,13,13,0,0,0,5.5-1.2,10,10,0,0,0,4.1-3.5h.1v3.5a17.52,17.52,0,0,1-.5,4,8.76,8.76,0,0,1-1.6,3.2,7,7,0,0,1-2.9,2.1,11.69,11.69,0,0,1-4.5.8,13.31,13.31,0,0,1-5.5-1.2,12.23,12.23,0,0,1-4.4-3.2l-3.4,4.2a16.61,16.61,0,0,0,6.2,3.6,20.17,20.17,0,0,0,7.1,1.3,16.69,16.69,0,0,0,7.1-1.3,11.93,11.93,0,0,0,7.1-8.1,21.21,21.21,0,0,0,.7-5.7V275.3h-5.2v4.3Zm-.4,12.7a7.71,7.71,0,0,1-1.9,3,8.37,8.37,0,0,1-2.9,2,10,10,0,0,1-7.6-.1,7.39,7.39,0,0,1-2.8-2.1,9.23,9.23,0,0,1-1.8-3,10.46,10.46,0,0,1-.6-3.6,11.48,11.48,0,0,1,.6-3.7,7.53,7.53,0,0,1,1.8-3,9.8,9.8,0,0,1,2.8-2.1,9.21,9.21,0,0,1,3.8-.8,9.57,9.57,0,0,1,3.8.8,7.75,7.75,0,0,1,2.9,2.1,9.53,9.53,0,0,1,1.9,3,11.06,11.06,0,0,1,.7,3.7A14.28,14.28,0,0,1,282.5,292.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M300,262a3.42,3.42,0,0,0-3.5,3.5,3,3,0,0,0,1,2.4,3.63,3.63,0,0,0,5,0,3.25,3.25,0,0,0,1.1-2.5,3.41,3.41,0,0,0-1.1-2.5A3.49,3.49,0,0,0,300,262Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 297.4,
    y: 275.3,
    width: 5.4,
    height: 27.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M318.2,267.5h-5.3v7.8h-5.2v4.4h5.2v14.7a9.43,9.43,0,0,0,2,6.4,7.87,7.87,0,0,0,5.9,2.1,17.91,17.91,0,0,0,2.4-.2,10.81,10.81,0,0,0,2.1-.5l-.2-4.4a8.8,8.8,0,0,1-1.5.5,10,10,0,0,1-1.6.2,3.69,3.69,0,0,1-2.9-1.1,5.44,5.44,0,0,1-.9-3.5V279.8h7.2v-4.4h-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M353,297V285.2a11.58,11.58,0,0,0-.7-4.2,9.24,9.24,0,0,0-2.1-3.4,9.7,9.7,0,0,0-3.5-2.3,13,13,0,0,0-5.1-.8,18,18,0,0,0-6.2,1.1,13.48,13.48,0,0,0-4.9,3l2.9,3.4a12,12,0,0,1,3.4-2.3,10.7,10.7,0,0,1,4.3-.9,7.73,7.73,0,0,1,4.9,1.5,5.52,5.52,0,0,1,1.8,4.5v.7c-2.3,0-4.6.1-6.8.3a26.37,26.37,0,0,0-6.1,1.2,10.91,10.91,0,0,0-4.4,2.7,6.94,6.94,0,0,0-1.7,4.9,8.16,8.16,0,0,0,.9,4,7.49,7.49,0,0,0,2.4,2.6,11.52,11.52,0,0,0,3.2,1.4,13.47,13.47,0,0,0,3.3.4,11.61,11.61,0,0,0,5.4-1.2,10.29,10.29,0,0,0,3.8-3.4h.2a17.37,17.37,0,0,0,.5,3.9h4.9a8.52,8.52,0,0,1-.3-2.5C353.1,298.9,353,298,353,297Zm-5.1-6.1a8.42,8.42,0,0,1-2,5.7,7.53,7.53,0,0,1-5.8,2.3,12.31,12.31,0,0,1-2-.2,6.7,6.7,0,0,1-1.8-.7,4,4,0,0,1-1.3-1.3,3.94,3.94,0,0,1-.5-2,3.53,3.53,0,0,1,1.1-2.7,6.68,6.68,0,0,1,2.9-1.5,22.56,22.56,0,0,1,3.9-.7c1.4-.1,2.8-.2,4.2-.2h1.3v1.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 362.1,
    y: 259.1,
    width: 5.4,
    height: 43.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoO3Digital);
export default __webpack_public_path__ + "static/media/logo-o3digital.8a11d523662567fbf4e235d7a6911d04.svg";
export { ForwardRef as ReactComponent };